import { Box, Button } from '@mui/material'
import { t, Trans } from '@lingui/macro'
import { FC } from 'react'
import { ContactFields, ContactFieldsValues } from './ContactFields'
import { AlertBanner } from 'app/views/common/alerts/AlertBanner'
import CustomButton from '../CustomButton'
import { isNil } from 'lodash'
import { ContactDialogType } from './useContactDialog'
import { myI18n } from 'translation/I18nConnectedProvider'
// import Loading from 'egret/components/EgretLoadable/Loading'

interface ContactFieldsMissingInfoProps {
  loading: boolean
  values: ContactFieldsValues
  onUpdate: (params: { values: ContactFieldsValues, isValid: boolean, initialValues: ContactFieldsValues }) => void
  onSwitch: (params: { dirty: boolean }) => void
  onClose: () => void
  type?: ContactDialogType
  role?: string
}

export const ContactFieldsMissingInfo: FC<ContactFieldsMissingInfoProps> = ({
  loading,
  values,
  onUpdate,
  onSwitch,
  onClose,
  type,
  role
}) => {
  return (
    <ContactFields
      initialValues={values}
      hiddenFields={{
        changeReason: true,
        providedOrganizationName: type === 'project-affiliations',
        jobTitle: type === 'project-affiliations'
      }}
      readonlyFields={{
        firstName: true,
        lastName: true,
        email: loading,
        phoneNumber: loading,
        phoneNumberCountryCode: loading,
        jobTitle: loading,
        providedOrganizationName: loading
      }}
      initialTouched={{
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        phoneNumberCountryCode: true,
        jobTitle: true
      }}
      requiredFields={{
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        phoneNumberCountryCode: true,
        jobTitle: true
      }}
      title={
        <>
          <Box
            sx={{
              marginBottom: '25px',
              fontWeight: 'bold',
              fontSize: 20,
              lineHeight: '25px',
              color: 'primary.main',
              textAlign: 'center'
            }}
          >
            {type === 'project-affiliations' && !isNil(role)
              ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}>
                  <Trans>PROJECT_AFFILIATIONS_UPDATE_TITLE</Trans>
                  <Box>{role}</Box>
                </Box>)
              : <Trans>UPDATE_LEGAL_CONTACT_TITLE</Trans>}
          </Box>
          <AlertBanner
            title={<Trans>UPDATE_LEGAL_CONTACT_BANNER_TITLE</Trans>}
            description={
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div><Trans>UPDATE_LEGAL_CONTACT_BANNER_DESCRIPTION</Trans></div>
                <div><Trans>UPDATE_LEGAL_CONTACT_BANNER_ADD_DESCRIPTION</Trans></div>
              </div>
            }
            sx={{ marginBottom: '24px' }}
          />
        </>
      }
    >
      {({ values, isValid, initialValues, dirty }) => {
        const handleUpdateClick: () => void = () => {
          onUpdate({
            values: {
              ...values,
              changeReason: myI18n._(t`MISSING_CONTACT_INFO`)
            },
            isValid,
            initialValues
          })
        }
        const handleSwitchClick: () => void = () => {
          onSwitch({ dirty })
        }
        const handleCloseClick: () => void = () => {
          onClose()
        }

        return (
          <>
            <Button
              disabled={!isValid || loading || !dirty}
              fullWidth
              color='primary'
              variant='contained'
              onClick={handleUpdateClick}
            >
              <Trans>UPDATE_CONTACT_INFO_BTN</Trans>
            </Button>
            <Box sx={{ display: 'flex', gap: '16px', marginTop: '16px' }}>
              <Button
                fullWidth
                color='primary'
                variant='outlined'
                disabled={loading}
                onClick={handleSwitchClick}
              >
                <Trans>SWITCH_CONTACT_BTN</Trans>
              </Button>
              <CustomButton
                variant='outlined'
                sx={{ height: '35px' }}
                onClick={handleCloseClick}
                disabled={loading}
              >
                <Trans>CLOSE_BTN</Trans>
              </CustomButton>
            </Box>
            {/* {loading && (
              <div style={{ marginTop: 15, height: 100 }}>
                <Loading isNotFixed />
              </div>
            )} */}
          </>
        )
      }}
    </ContactFields>
  )
}
